@if (dataFields !== null) {
    @for (field of dataFieldsByGroup; track field.id) {
        <div class="{{ field.type }}">
            <label>{{ field.name | ucfirst }}:</label>
            <div [class.blur]="field.isEncrypted">{{ getDataValueByDataField(field) }}</div>
        </div>
    }
} @else {
    <div class="loadable loading"></div>
}
